import { useQuery } from '@tanstack/react-query'
import { getUserRoles } from '../services/authService'

export function useUserRoles() {
  return useQuery({
    queryKey: ['userRoles'],
    queryFn: () => getUserRoles({ pageNum: '1', pageSize: '10' }),
    select: (data) => data.data.roles,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export function useUserRolesData() {
  return useQuery({
    queryKey: ['userRolesData'],
    queryFn: () => getUserRoles({ pageNum: '1', pageSize: '10' }),
    select: (data) => data.data,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export function useIsSuperuser() {
  const { data: roles, isLoading } = useUserRoles()

  const isSuperuser = roles?.includes('SUPERUSER') || false

  return {
    isSuperuser,
    isLoading,
    roles: roles || [],
  }
}
